export const acquisitionLink = 'https://techcrunch.com/2026/09/02/adobe-acquires-indian-market-intelligence-startup-rilo/';

export const workEntries = [
  {
    id: 'adobe',
    name: 'Adobe',
    year: '2026–now',
    role: 'Machine learning',
    current: true,
    description: 'Joined Adobe with the Rilo team following the acquisition. Based in Bengaluru.',
  },
  {
    id: 'rilo',
    name: 'Rilo',
    year: '2025–26',
    role: 'Founding team',
    status: 'Acquired by Adobe',
    statusLink: acquisitionLink,
    description: 'We started with a workflow builder driven by plain English, then moved into AI employees for go-to-market teams. I also built MCP tools that teams could connect to their own agents for research, personalized outreach, and running workflows.',
  },
  {
    id: 'lumen',
    name: 'Stealth / Lumen',
    year: '2025',
    role: 'Co-founder at Stealth · Interim CTO at Lumen',
    description: 'Built Lumen, an AI visibility platform for commerce brands, and owned its technology end to end. We reached $156K in annual recurring revenue across eight customers in two months.',
    exploration: 'At Stealth, I also explored intelligence for engineering managers and a digital career passport.',
  },
  {
    id: 'instawork',
    name: 'Instawork',
    year: '2024–25',
    role: 'Product & AI engineering',
    description: 'Built AI products for customer support and hiring, spanning support automation, job recommendations, and voice interviews.',
  },
  {
    id: 'blaze',
    name: 'Blaze AI',
    year: '2023–24',
    role: 'Founding engineer · YC-backed',
    description: 'Built and led development across Blaze’s outreach and customer-data products, including prospecting, social listening, personalized campaigns, a shared inbox, and a wallet CRM.',
  },
  {
    id: 'autoave',
    name: 'Autoave',
    year: '2021–22',
    role: 'Co-founder',
    description: 'A car-care marketplace connecting customers with local service providers. I co-founded the business and built its booking and store-management software. We onboarded more than 40 stores.',
  },
];

export const gsocLink = 'https://atpug22.medium.com/google-summer-of-code-2021-with-oppia-d61fb8c848ca';
export const instagramLink = 'https://www.instagram.com/_ryaman/';
export const twitterLink = 'https://x.com/_ryaman';
